export class MainNavigation {
  constructor(navigation) {
    this.navigation = navigation;
    this.html = document.querySelector("html");
    this.toggleButton = this.navigation.querySelector("[data-toggle]");
    this.navigationPanelView =
      this.navigation.querySelector("[data-panel-view]");

    this.toggleButton?.addEventListener("click", () => {
      this.toggleNav();
    });

    this.navigation.querySelectorAll("[data-close]").forEach((item) => {
      item.addEventListener("click", () => {
        this.toggleNav(false);
      });
    });

    this.navigationPanelView
      .querySelectorAll(".menu-item-has-children > a")
      .forEach((item) => {
        item.addEventListener("click", (e) => {
          e.preventDefault();
          item.parentNode.toggleAttribute("data-opened");
        });
      });
  }

  toggleNav(force) {
    this.navigation.classList.toggle("main-navigation--opened", force);
    document.documentElement.toggleAttribute(
      "data-main-navigation-opened",
      force
    );
  }
}
